import styled from 'styled-components';

export const StyledIntlRfpHeader = styled.div``;
